import { ITeam, ITournament } from "../../../../../types/api";
import { IHomeLeague } from "../../../../../types/forms";

export const findHomeLeague = (
    teamId: ITeam["id"],
    homeLeagues: ITournament["schedulingData"]["homeLeagues"],
    allHomeLeagues: IHomeLeague[],
) => {
    for (const homeLeagueId in homeLeagues) {
        let leagueData: number[] | { [key: string]: number[] };

        if (homeLeagueId === "0") {
            leagueData = homeLeagues[homeLeagueId] as {
                [key: string]: number[];
            };
            for (const leagueName in leagueData) {
                if (leagueData[leagueName].includes(teamId)) {
                    return {
                        value: 0,
                        label: leagueName,
                    };
                }
            }
        } else {
            leagueData = homeLeagues[homeLeagueId] as number[];
            if (leagueData.includes(teamId)) {
                return {
                    value: parseInt(homeLeagueId),
                    label: allHomeLeagues.find(
                        l => l.id === parseInt(homeLeagueId),
                    )?.name as string,
                };
            }
        }
    }
    return null;
};
